/* The header chip look and Escape-to-close shared by the Account switcher and the
   Statistics range chip. */

import { useEffect } from 'react';
import { C } from './ChatAssistant/compact/tokens';
import { font as f } from './ChatAssistant/compact/style';

export const chip: React.CSSProperties = {
  height: 30, padding: '0 10px', display: 'flex', alignItems: 'center', gap: 6, background: C.input,
  border: `1px solid ${C.borderHi}`, borderRadius: 6, color: 'var(--om-body)', font: f(500, 12), whiteSpace: 'nowrap', cursor: 'pointer',
};

export function useCloseOnEscape(open: boolean, close: () => void) {
  useEffect(() => {
    if (!open) return;
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', k);
    return () => window.removeEventListener('keydown', k);
  }, [open, close]);
}
